import React, {useRef} from "react";
import {$searchIconLight} from "../../assets/icons";

interface IProps {
    title?: string,
    value: string,
    placeholder?: string,
    disabled?: boolean,
    bgColor?: string,
    onChangeText?: (text: string) => void,
    onFinishText?: () => void,
    errMsg?: string
}

function SearchForm(props: IProps) {
    const {title, placeholder, onChangeText, onFinishText, value, disabled = false, errMsg = "", bgColor = "bg-light-blue"} = props

    const inputRef = useRef<HTMLInputElement>(null)

    const $errMsg = errMsg.length ? <p className="text-red-500 text-sm italic">{errMsg}</p> : null
    const $title = title ? <p className={"relative text-gray-1 text-sm text-left"}>{title}</p> : null
    return (
        <div className={"w-full"}>
            {$title}
            <div className={"relative flex flex-row justify-between items-center h-10"}>
                <div className={"absolute left-2"}>
                    {$searchIconLight}
                </div>
                <input ref={inputRef} disabled={disabled} value={value} placeholder={placeholder} onKeyUp={(e) => {
                    if (e.key.toLowerCase() === "enter") {
                        onFinishText && onFinishText()
                        inputRef.current?.blur()
                    }
                }} onChange={(e) => {
                    onChangeText && onChangeText(e.target.value)
                }} className={`form-text text-sm w-full h-full px-8 ${bgColor} rounded-lg focus:outline-none border ${errMsg && errMsg.length ? "bg-error-20 border border-error focus:border-error" : "border border-transparent focus:border-theme-blue focus:ring-4 focus:ring-color-theme "}`} />
            </div>
            {$errMsg}
        </div>
    )
}

export default SearchForm
